import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/service/api.service';
import { Product } from 'src/Model/Product-Interfaces';
import { pageSegment, brandUrl } from 'src/app/brand/brand-context';

@Component({
  selector: 'app-car-listing',
  templateUrl: './searched-car.component.html',
  styleUrls: ['./searched-car.component.scss'],
})
export class SearchedCarComponent implements OnInit, OnDestroy {
  @Input() product: Product;
  webCusSub: Subscription;
  CurrencySymbol: string;
  constructor(
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnDestroy(): void {
    this.webCusSub.unsubscribe();
  }

  ngOnInit(): void {
    this.getWebCustomer();
  }

  getWebCustomer() {
    this.webCusSub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }
      this.CurrencySymbol = res.TemplateData.CurrencySymbol || 'GBP';
    });
  }

  openUrl() {
    let component = pageSegment();
    // only the two car lists have a details child route; from anywhere else
    // (home, reservation, enquiry …) open it under stock-list
    if (component != 'sold-cars') component = 'stock-list';

    this.router.navigateByUrl(
      brandUrl(`${component}/details/${this.product.ProductId}`)
    );
  }
  enquireNow() {
    window.location.href = 'https://camcarsales.co.uk/contact/';
  }
}
